import { FrontendProductSchema } from "@redotech/redo-model/agents/support-agents/frontend-product";
import * as z from "zod/v4";

export const lookupProductsByIds = {
  name: "lookupProductsByIds" as const,
  input: z.object({ productIds: z.array(z.string()) }),
  output: z.array(FrontendProductSchema),
};
